import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const DollarIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M16.9999 16.022C17.0105 14.5189 16.4382 13.3301 15.2966 12.4906C14.4149 11.8442 13.3449 11.507 12.3101 11.183C10.1542 10.5044 9.52884 10.147 9.52884 9.07666C9.52884 7.88439 11.0212 7.46017 12.2988 7.46017C13.2293 7.46017 14.2997 7.76052 14.9645 8.20564L16.2825 6.08642C15.4136 5.50163 14.2245 5.10275 13.0503 4.97894V3H10.6191V5.11771C8.45789 5.61131 7.09647 7.07782 7.09647 9.07666C7.09647 10.4765 7.65675 11.5867 8.75857 12.3697C9.59659 12.9675 10.6186 13.2885 11.6059 13.5993C13.7205 14.2629 14.5792 14.6672 14.5694 16.0064L14.5694 16.0163C14.5694 17.1403 13.1347 17.5398 11.9056 17.5398C10.7445 17.5398 9.48193 17.0115 8.76624 16.226L7 17.9606C7.90636 18.9559 9.2232 19.6596 10.619 19.9354V22H13.0503V19.9798C15.4518 19.6229 16.9975 18.1218 16.9999 16.022Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

DollarIcon.propTypes = {
  sx: PropTypes.object,
};

export default DollarIcon;
